import Vue from 'vue'
import VueJwtDecode from 'vue-jwt-decode'
import api from './services'
import Swal from 'sweetalert2'
var numeral = require('numeral')
var moment = require('moment')

Vue.mixin({
  data() {
    return {
      header: {
        headers: {
          'Access-Token': localStorage.token,
          'Public-Token':
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiT3BlbiBIb3VzZSBSTVVUTCIsInR5cGUiOiJ3ZWJfYXBpIiwiY3JlYXRlIjoiMjAyMi0wOS0wOSAwOTowOTowOSJ9.s8p__DdvjrhZAJAN0Nc8CVV1TnaGHPvXR7NMg-OSl80',
        },
      },
    }
  },
  methods: {
    THAIIDCHECK(idCardNumber) {
      if (typeof idCardNumber === 'number') {
        idCardNumber = idCardNumber.toString()
      }

      const regex = /^[0-9]\d*$/
      if (
        idCardNumber.length === 13 &&
        idCardNumber.match(regex) &&
        idCardNumber !== null &&
        idCardNumber !== 'undefined'
      ) {
        // Check valid id card number
        // return this.idCardCheck(idCardNumber)
        return true
      } else {
        return false
      }
    },
    idCardCheck(idCardNumber) {
      var sum = 0
      for (var i = 0; i < idCardNumber.length - 1; i++) {
        sum += parseInt(idCardNumber[i]) * (13 - i)
      }

      var checkDigit = (11 - (sum % 11)) % 10

      if (checkDigit === idCardNumber[12]) {
        return true
      } else {
        return false
      }
    },
    checkUser() {
      if (
        localStorage.token === 'undefined' ||
        localStorage.token === undefined ||
        localStorage.token === null ||
        localStorage.token === ''
      ) {
        localStorage.clear()
        this.$router.push('/')
      } else {
        this.checkToken(localStorage.token)
      }
    },
    checkToken(token) {
      let jwt = VueJwtDecode.decode(token)
      let TimoOutLogin = this.daysDiff(jwt.create, jwt.expire)
      if (parseInt(TimoOutLogin) <= 0) {
        Swal.fire({
          icon: 'error',
          title: 'ตรวจสอบการใช้งาน',
          text: 'ท่านเข้าใช้งานเกินเวลาที่กำหนด',
        })
        localStorage.clear()
        this.$router.push('/')
      } else {
        this.getProfile()
      }
    },
    callbackToken(citizenId) {
      if (
        localStorage.token === 'undefined' ||
        localStorage.token === undefined ||
        localStorage.token === null ||
        localStorage.token === ''
      ) {
        return false
      } else {
        let jwt = VueJwtDecode.decode(localStorage.token)
        let TimoOutLogin = this.daysDiff(jwt.create, jwt.expire)
        if (parseInt(TimoOutLogin) > 0) {
          return true
        } else {
          if (citizenId) {
            api.OAuthCheck(
              this.$store.state.URL,
              { citizenId: citizenId },
              this.header,
              (result) => {
                if (result.status === 'SUCCESS') {
                  localStorage.token = result.data.accessToken
                  return true
                } else if (result.status === 'NOT_REGISTER') {
                  return false
                } else {
                  return false
                }
              },
              (_error) => {
                return false
              },
            )
          } else {
            return false
          }
        }
      }
    },
    OAuth(citizenId) {
      this.$store.state.isLoading = true
      api.OAuthCheck(
        this.$store.state.URL,
        { citizenId: citizenId },
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            localStorage.token = result.data.accessToken
            this.getProfile()
          } else if (result.status === 'NOT_REGISTER') {
            this.$router.push('/regis?id=' + citizenId)
          } else {
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ตกลง',
            }).then((_result) => {
              localStorage.clear()
              this.$router.push('/')
            })
          }
          this.$store.state.isLoading = false
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/')
        },
      )
    },
    getProfile() {
      this.header.headers['Access-Token'] = localStorage.token
      api.getProfile(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.user = result.data
            this.$store.state.isLoading = false
          } else {
            this.$store.state.isLoading = false
            localStorage.clear()
            this.$router.push('/')
          }
        },
        (_error) => {
          localStorage.clear()
          this.$router.push('/')
          this.$store.state.isLoading = false
        },
      )
    },
    daysDiff(d1, d2) {
      var startDate = moment(d1).format('x')
      // Do your operations
      var endDate = moment(d2).format('x')
      var seconds = (endDate - startDate) / 60000
      return Math.floor(seconds)
    },
    dateYearThai(date) {
      return moment(date).format('YYYY')
    },
    dateMonth(date) {
      return moment(date).format('YYYY-MM')
    },
    dateTimeFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    dateFormat(date) {
      return moment(date).format('L')
    },
    dateFormatDMY(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    dateFormatDMY2(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    dateFormatMY(date) {
      return moment(date).format('MM/YYYY')
    },
    monthFormat(str) {
      switch (str) {
        case '01':
          return 'ม.ค'
        case '02':
          return 'ก.พ'
        case '03':
          return 'มี.ค'
        case '04':
          return 'เม.ย'
        case '05':
          return 'พ.ค'
        case '06':
          return 'มิ.ย'
        case '07':
          return 'ก.ค'
        case '08':
          return 'ส.ค'
        case '09':
          return 'ก.ย'
        case '10':
          return 'ต.ค'
        case '11':
          return 'พ.ย'
        default:
          return 'ธ.ค'
      }
    },
    monthYearFormat(str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0]
        case '02':
          return 'กุมภาพันธ์ ' + date[0]
        case '03':
          return 'มีนาคม ' + date[0]
        case '04':
          return 'เมษายน ' + date[0]
        case '05':
          return 'พฤษภาคม ' + date[0]
        case '06':
          return 'มิถุนายน ' + date[0]
        case '07':
          return 'กรกฎาคม ' + date[0]
        case '08':
          return 'สิงหาคม ' + date[0]
        case '09':
          return 'กันยายน ' + date[0]
        case '10':
          return 'ตุลาคม ' + date[0]
        case '11':
          return 'พฤศจิกายน ' + date[0]
        default:
          return 'ธันวาคม ' + date[0]
      }
    },
    dateThaiFormat(str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return date[2] + ' มกราคม ' + (parseInt(date[0]) + 543)
        case '02':
          return date[2] + ' กุมภาพันธ์ ' + (parseInt(date[0]) + 543)
        case '03':
          return date[2] + ' มีนาคม ' + (parseInt(date[0]) + 543)
        case '04':
          return date[2] + ' เมษายน ' + (parseInt(date[0]) + 543)
        case '05':
          return date[2] + ' พฤษภาคม ' + (parseInt(date[0]) + 543)
        case '06':
          return date[2] + ' มิถุนายน ' + (parseInt(date[0]) + 543)
        case '07':
          return date[2] + ' กรกฎาคม ' + (parseInt(date[0]) + 543)
        case '08':
          return date[2] + ' สิงหาคม ' + (parseInt(date[0]) + 543)
        case '09':
          return date[2] + ' กันยายน ' + (parseInt(date[0]) + 543)
        case '10':
          return date[2] + ' ตุลาคม ' + (parseInt(date[0]) + 543)
        case '11':
          return date[2] + ' พฤศจิกายน ' + (parseInt(date[0]) + 543)
        default:
          return date[2] + ' ธันวาคม ' + (parseInt(date[0]) + 543)
      }
    },
    numberFormat(str) {
      return numeral(str).format('0,0.00')
    },
    numberFormat2(str) {
      return numeral(str).format('00')
    },
    numberFormatold(str) {
      return numeral(str).format('0,0')
    },
  },
})



// WEBPACK FOOTER //
// ./src/assets/mixin.js